import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { updateOfferingCategory } from '../api/offeringCategories';
import type { OfferingCategoryFormValues } from '../types';
import { notification } from 'antd';

export function useUpdateOfferingCategory(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OfferingCategoryFormValues) => {
      if (!id) throw new Error('ID is required to update category');
      return updateOfferingCategory(id, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Category updated successfully' });
      invalidateListResource(queryClient, 'offering-categories');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to update category' });
    },
  });
}
